export const ENV = {
    LOCALE: process.env.VUE_APP_SHIELD_I18N_LOCALE || 'en',
    FALLBACK_LOCALE: process.env.VUE_APP_SHIELD_I18N_FALLBACK_LOCALE || 'en',
    SOCKET_ENDPOINT: process.env.VUE_APP_SHIELD_SOCKET_ENDPOINT,
    IS_PRODUCTION: process.env.VUE_APP_IS_PRODUCTION === 'true',
    API_DOMAIN: process.env.VUE_APP_API_DOMAIN,
    SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN || '',
    DOMAIN: process.env.VUE_APP_DOMAIN,
    GRAFANA_URL: process.env.VUE_APP_GRAFANA_URL || '',
}
